import { Suspense } from "react";
import { BrowserRouter } from "react-router";
import { MantineProvider, Loader } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { ModalsProvider } from "@mantine/modals";
import { theme } from "@/config/theme";
import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";

import "react-international-phone/style.css";
import "./App.css";

import Router from "./routes";

function App() {
  return (
    <BrowserRouter basename="app">
      <MantineProvider theme={theme}>
        <Notifications />
        <Suspense
          fallback={
            <div
              style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Loader color="#000000" />
            </div>
          }
        >
          <ModalsProvider>
            <Router />
          </ModalsProvider>
        </Suspense>
      </MantineProvider>
    </BrowserRouter>
  );
}

export default App;
